import { useContext } from 'react';
import LocalStorageService from '../../../../Services/LocalStorageService';
import PatientManagementService from '../../../../Services/PatientManagementService';
import { WarningDialogHandler } from '../../../../SharedComponents/Dialog/Warning/WarningDialog';
import { VoidReturn } from '../../../../Utils/PageUtils';
import { InitialSettingContext } from '../InitialSettingContext';
import useInitialSettingApplyHandler from '../SideApplication/InitialSettingApplyHandlerHook';

export type LeftRightDifferenceHandler = {
    onExit: () => VoidReturn;
    onContinue: () => VoidReturn;
    getLoading: () => boolean | undefined;
};

export default function useLeftRightDifferenceHandler(): WarningDialogHandler {
    const { exitInitialSetting } = useContext(InitialSettingContext);

    const { onClickApply } = useInitialSettingApplyHandler();

    const redoHLAA = async () => {
        await PatientManagementService.redoHLAA();
        LocalStorageService.serviceInstance.clear(false);
        await PatientManagementService.getPatient();
    };

    async function onExit() {
        await redoHLAA();
        exitInitialSetting('mismatch');
    }

    async function onContinue() {
        onClickApply();
    }

    return {
        secondaryAction: onExit,
        primaryAction: onContinue,
    };
}
